module.exports = __webpack_public_path__ + "static/bg-504a721931f30d1396be20295da07601.png";